import { PrescriptionInterface } from '../interfaces';
import { createTableColumns } from '../utils';

import Axios from "../libraries/axios";

class MdIntegrationsModel implements PrescriptionInterface {
	[key: string]: any
	timestamp = 0;
	event_type = '';
	test = false;
	metadata = {};
	encounter_id = '';
	case_id = '';
	prescriptions = [];
	services = [];
	patient_id = '';
	message_id = '';
	channel = '';
	voucher_id = '';
	internal_id = '';

	constructor(props: PrescriptionInterface) {
	  if (props) {
	    Object.assign(this, props);
	  }
	}

	static getColumns() {
	  return createTableColumns(['event_type', 'latestPrescription', 'createdAt']);
	}

	static async fetchAll<ReturnType>(
	  params: any = {},
	  config: any = {}
	): Promise<ReturnType> {
	  try {
	    const { data } = await Axios.get('/api/md-integrations-events', {
	      params,
	      ...config,
	    });

	    const getLatestPrescription = (data: { [key: string]: any }) => {
	      if (!data.prescriptions || data.prescriptions.length === 0) {
	        return null;
	      }

	      const latestPrescription = data.prescriptions.reduce((latest: any, current: any) => {
	        const latestDate = new Date(latest.updatedAt || latest.createdAt);
	        const currentDate = new Date(current.updatedAt || current.createdAt);

	        return currentDate > latestDate ? current : latest;
	      });

	      return latestPrescription.name;
	    };

	    data.data.map((item: { [key: string]: any }) => {
	      item.latestPrescription = getLatestPrescription(item);
	      return item;
	    });

	    return data;
	  } catch (e: any) {
	    throw new Error(e);
	  }
	}
}

export default MdIntegrationsModel;
